import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, debounceTime, distinctUntilChanged, filter, Subscription, switchMap } from 'rxjs';
import { SHORT_DEBOUNCE_TIME } from 'src/app/extensions/constants/commonConstants';
import { FrequentlyAskedQuestionsAPIService } from 'src/app/extensions/services/api/faq-api.service';

@Component({
  selector: 'faq-list',
  templateUrl: './faq-list.component.html',
  styleUrls: ['./faq-list.component.scss'],
  standalone: false,
})
export class FrequentlyAskedQuestionsListComponent implements OnInit, OnDestroy {
  constructor(private _faqAPIService: FrequentlyAskedQuestionsAPIService) {}

  public hasNoData = true;
  public frequentlyAskedQuestions: app.models.FAQModel[];
  public props: app.models.DynamicPropsDictionary;

  public subscriptions: Subscription[] = [];
  public searchQuery$ = new BehaviorSubject<string>('');

  ngOnInit() {
    let subscription: Subscription = this.searchQuery$
      .pipe(
        debounceTime(SHORT_DEBOUNCE_TIME),
        filter(x => x?.length == 0 || x?.length >= 3),
        distinctUntilChanged(),
        switchMap(result => this._faqAPIService.getFilteredFrequentlyAskedQuestions(result))
      )
      .subscribe(result => {
        this.frequentlyAskedQuestions = result.data;
        this.props = result.props;
        this.hasNoData = result.data.length == 0;
      });
    this.subscriptions.push(subscription);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }
}
